import { TextField, TextFieldProps } from '@mui/material';

// Reference: https://mui.com/material-ui/api/text-field/
const FormTextField = ({ sx, ...props }: TextFieldProps) => {
  return <TextField {...props} sx={{ width: '100%' }} />;
};

export { FormTextField };
